import {
  ButtonBase,
  IconButton as MuiIconButton,
  List,
  ListItem,
  ListItemText,
  Popover,
  Typography,
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { useState } from 'react'

import CustomControl from '@/components/map/custom-control'
import { useDownloadFilesFromDemand } from '@/hooks/mutations/use-download-files-from-demand'
import { DownloadTypes } from '@/services/get-url-to-download-file'

import { useDemandAnalysisRoute } from '../../hooks/use-demand-analysis-route'
import { useStyles } from './styles'

export function ExportButton() {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const { diagnosisId, culture } = useDemandAnalysisRoute()

  const { mutate } = useDownloadFilesFromDemand(culture!, diagnosisId!)

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleOptionClick = (option: DownloadTypes) => {
    mutate({ type: option })
    handleClose()
  }

  return (
    <>
      <CustomControl style={{ overflow: 'hidden' }} position='bottomright'>
        <ButtonBase
          className={classes.root}
          aria-label={'Exportar arquivos'}
          onClick={handleOpen}
        >
          <span className='material-symbols-outlined'>download</span>
        </ButtonBase>
      </CustomControl>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 28,
          horizontal: 29,
        }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        classes={{ paper: classes.popoverPaper }}
        elevation={1}
      >
        <div className={classes.popoverHeader}>
          <Typography variant='h6'>Exportar arquivos</Typography>
          <MuiIconButton
            aria-label='close'
            className={classes.closeButton}
            size='small'
            onClick={handleClose}
          >
            <CloseIcon />
          </MuiIconButton>
        </div>
        <List classes={{ root: classes.list }} disablePadding dense>
          <ListItem button onClick={() => handleOptionClick('perimeter')}>
            <span>&bull;</span>
            <ListItemText primary='Perímetro' />
          </ListItem>
          <ListItem button onClick={() => handleOptionClick('mosaic')}>
            <span>&bull;</span>
            <ListItemText primary='Ortomosaico' />
          </ListItem>
        </List>
      </Popover>
    </>
  )
}
